/**
 * Loader de temas (D12, onda 3 — "tema é dado"): "default" vem do bundle (piso, garante um
 * tema válido mesmo com o Static totalmente fora); os demais via fetch no Static
 * ({id}.json → seção `admin`). Nenhum outro tema é bundled — publicar um tema novo não
 * exige deploy do Admin.
 */
import defaultThemeJson from '../themes/templates/default.json';
import { isDevEnvironment } from './environment';

const STATIC_CDN_DEV = 'https://static.dev.agendario.com.br';
const STATIC_CDN_PROD = 'https://static.agendario.com.br';
const THEMES_CDN_BASE = `${isDevEnvironment() ? STATIC_CDN_DEV : STATIC_CDN_PROD}/themes`;

/**
 * Carrega a seção `admin` (colors/fonts/icons/labels/messages/serviceCategories/customStyles/
 * welcome/id/name/description) do {id}.json. Falha de qualquer natureza (rede, 404, JSON
 * malformado, seção ausente) cai no default bundled — nunca lança (D13).
 * @param {string} themeId
 * @returns {Promise<Object>}
 */
export const loadTemplate = async (themeId) => {
  if (themeId === 'default') return defaultThemeJson;

  try {
    const response = await fetch(`${THEMES_CDN_BASE}/${themeId}.json`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const fullDefinition = await response.json();
    if (!fullDefinition.admin) throw new Error('JSON sem seção "admin"');
    return fullDefinition.admin;
  } catch (error) {
    console.warn(`Tema "${themeId}" indisponível no Static. Usando tema padrão.`, error);
    return defaultThemeJson;
  }
};
